
export default {
  setA (state, data) {
    state.aaa = data
  }
}



// WEBPACK FOOTER //
// ./src/store/sys_manage/mutations.js